export default {

  //获取纪念堂列表
  findSpaceList: '/bygDeadManV2/find',

  //获取告别厅列表-全部
  findAllList: '/bygFarewellHall/findAll',

  //获取单位信息列表（全部）
  findAppInfoAll: '/bygApp/findAppInfoAll',

  //新建纪念堂信息
  addSpace: '/bygDeadManV2/add',

  //新建/编辑告别会
  addOrEdit: '/bygAMV2/addOrEdit',

  //获取纪念堂日志列表
  findLog: '/bygDeadManV2/findLog',

  //获取纪念堂详情
  findById: '/bygDeadManV2/findById',

  //获取纪念堂详情-成员列表
  findUserDmRelationById: '/bygDeadManV2/findUserDmRelationById',

  //获取纪念堂详情-留言列表
  findSignInById: '/bygDeadManV2/findSignInById',

  //获取背景模板列表
  findAllBgTemplate: '/bygDeadManV2/findAllBgTemplate',

  //获取背景模板列表V2
  findAllBgTemplateV2: '/bygDeadManV2/findAllBgTemplateV2',

  //获取音乐模板列表
  findAllMusicTemplate: '/bygDeadManV2/findAllMusicTemplate',

  //获取纪念堂日志列表
  findDeadLog: '/bygDeadManV2/findLog',

  //编辑纪念堂陵园使用信息
  editCemeteryById: '/bygDeadManV2/editCemeteryById',

  //编辑纪念堂信息
  editById: '/bygDeadManV2/editById',

  //纪念堂操作权限申请
  editUpdateStateById: '/bygDeadManV2/editUpdateStateById',

  //纪念堂上传权限申请
  editUploadStateById: '/bygDeadManV2/editUploadStateById',

  //访问码冻结管理
  editVisitorFrozenById: '/bygDeadManV2/editVisitorFrozenById',

  //纪念堂冻结管理
  editSpaceFrozenById: '/bygDeadManV2/editSpaceFrozenById',

  //获取文件地址数据流
  getUrlDataSource: '/common/getUrlDataSource',

  //纪念堂操作权限取消
  cancelUpdateStateById: '/bygDeadManV2/cancelUpdateStateById',

  //获取地址响应码
  getUrlConnectionCode:'/common/getUrlConnectionCode',

  //获取OSS上传文件状态
  getOssFileState:'/common/getOssFileState',

  //纪念堂上传权限取消
  cancelUploadStateById:'/bygDeadManV2/cancelUploadStateById',

  //编辑纪念堂上传信息
  editUploadById: '/bygDeadManV2/editUploadById',

  //获取纪念堂上传列表
  findUploadByDmId: '/bygDeadManPhoto/findPhotoByDmId',

  //添加纪念堂日志
  saveLog: '/bygDeadManV2/saveLog',

  //编辑逝者姓名
  editDeadNameById: '/bygDeadManV2/editDeadNameById',

  //获取微信支付信息
  getWxPayOrder: '/mobile/bygOrder/getWxPayOrderH5',

  //删除上传文件
  delUploadById: '/bygDeadManV2/delUploadById',

  //相册-列表
  findPhotoCategory: '/bygDeadManPhoto/findPhotoCategory',

  //相册-新建/编辑
  addOrEditPhotoCategory: '/bygDeadManPhoto/addOrEditPhotoCategory',

  //相册-删除
  delPhotoCategory: '/bygDeadManPhoto/delPhotoCategory',

  //照片-空间照片列表
  findPhotoByDmId: '/bygDeadManPhoto/findPhotoByDmId',

  //照片-相册照片列表
  findPhotoByCategoryId: '/bygDeadManPhoto/findPhotoByCategoryId',

  //照片-上传相册照片
  addPhotoByCategoryId: '/bygDeadManPhoto/addPhotoByCategoryId',

  //照片-删除
  delPhotoById: '/bygDeadManPhoto/delPhotoById',

  //照片-修改备注
  editPhotoRemark: '/bygDeadManPhoto/editPhotoRemark',

  //照片-互换位置
  editPhotoPosition: '/bygDeadManPhoto/editPhotoPosition',

  //相册-迁移列表
  findMovePhotoCategory: '/bygDeadManPhoto/findMovePhotoCategory',

  //照片-迁移
  movePhoto: '/bygDeadManPhoto/movePhoto',

  //纪念堂成员总数
  getUserCount: '/bygDeadManV2/getUserCount',

  //照片-拖动排序
  dragPhoto: '/bygDeadManPhoto/sortPhoto',

  //投屏-获取视频相关内容
  getCoverVideo: '/bygDeadManV2/getCoverVideoV2',

  //纪念堂详情-获取APP认领码
  getClaimCodeUrl: '/bygDeadManV2/getClaimCodeUrl',
  //纪念堂详情-获取认领码
  getClaimCodeUrlAll: '/bygDeadManV2/getClaimCodeUrlAll',

  //人生相册-获取信息
  getLifeAlbumByDmId: '/bygLifeAlbum/findByDmId',
  //人生相册-获取照片
  findLifeAlbumPhotoAllByDmId: '/bygLifeAlbum/findPhotoAllByDmId',
  //人生相册-添加照片
  addLifeAlbumPhotoByDmId: '/bygLifeAlbum/addPhotoByDmId',
  //人生相册-拖动照片
  draggableLifeAlbumPhoto: '/bygLifeAlbum/draggablePhoto',
  //人生相册-删除照片
  delLifeAlbumPhotoByIds: '/bygLifeAlbum/delPhoto',
  //人生相册-获取背景模板
  findLifeAlbumTemplateBg: '/bygLifeAlbum/findTemplateBg',
  //人生相册-获取音乐模板
  findLifeAlbumTemplateMusic: '/bygLifeAlbum/findTemplateMusic',
  //人生相册-获取字幕模板1-人生角色
  findLifeAlbumSubtitle1: '/bygLifeAlbum/findTemplateSubtitle1',
  //人生相册-获取字幕模板2-人才类型
  findLifeAlbumSubtitle2: '/bygLifeAlbum/findTemplateSubtitle2',
  //人生相册-获取字幕模板3-天命
  findLifeAlbumSubtitle3: '/bygLifeAlbum/findTemplateSubtitle3',
  //人生相册-添加人生相册
  addLifeAlbumByDmId: '/bygLifeAlbum/addByDmId',
  //人生相册-添加人生相册-监听是否完成
  addLifeAlbumListener: '/bygLifeAlbum/addListener',
  //人生相册-清空人生相册
  cleanLifeAlbumByDmId: '/bygLifeAlbum/cleanByDmId',
  //人生相册-更新当前状态
  updateLifeAlbumStateByDmId: '/bygLifeAlbum/updateStateByDmId',
  //人生相册-获取照片相框
  findLifeAlbumPhotoFrameById: '/bygLifeAlbum/findPhotoFrameById',
  //人生相册-修改照片裁剪
  editLifeAlbumPhotoCropperUrl: '/bygLifeAlbum/editPhotoCropperUrl',
  //人生相册-取消照片裁剪
  cancelLifeAlbumPhotoCropperUrl: '/bygLifeAlbum/cancelPhotoCropperUrl',
  //人生相册-优化照片-AI
  editLifeAlbumPhotoAiUrl: '/bygLifeAlbum/editPhotoAiUrl',
  //人生相册-优化照片-AI-确认
  confirmLifeAlbumPhotoAiUrl: '/bygLifeAlbum/confirmPhotoAiUrl',
  //人生相册-替换照片-AI
  replaceLifeAlbumPhotoAiUrl: '/bygLifeAlbum/replacePhotoAiUrl',
  //人生相册-替换全部照片-AI
  replaceLifeAlbumPhotoAiUrlAll: '/bygLifeAlbum/replacePhotoAiUrlAll',
  //人生相册-上传视频到纪念堂资料
  uploadLifeAlbumVideoToDmPhoto: '/bygLifeAlbum/uploadVideoToDmPhoto',
  //人生相册-下载视频
  downloadLifeAlbumVideo: '/bygLifeAlbum/downloadVideo',
  //人生相册-AI照片合成-提取头像
  compositeLifeAlbumPhotoAiHeadPic: '/bygLifeAlbum/compositePhotoAiHeadPic',
  //人生相册-AI照片处理-着色、消除折痕、照片合成
  callLifeAlbumPhotoAi: '/bygLifeAlbum/callPhotoAi',
  //人生相册-上传照片到纪念堂资料
  uploadLifeAlbumPhotoToDmPhoto: '/bygLifeAlbum/uploadPhotoToDmPhoto',
  

}



// WEBPACK FOOTER //
// ./src/api/Space/urls.js